import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import WorkspaceBlock from "../../Components/Workspace";
import PageHeader from "../../Components/Common/PageHeader";

const WorkspacePage = () => {
  useEffect(() => {
    Utils.setPageTitle("Workspaces");
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader 
          title="Workspaces" 
          description="Manage your workspaces and team members" 
          icon={faUsers} 
        />

        <WorkspaceBlock />
      </div>
    </main>
  );
};

export default WorkspacePage;
